<span class="promemoria-badge-wrapper" onkeypress="" (click)="navigaAPromemoria()" pTooltip="Promemoria" tooltipPosition="bottom">
  <div class="p-overlay-badge">
    <i class="pi pi-bell"  style="font-size: 1.5rem; color: white"></i>
    @if (totalePromemorie > 0) {
      <p-badge [value]="totalePromemorie.toString()" severity="danger" />
    }
  </div>
</span>